if (!customElements.get('ceq-tabs')) {
  customElements.define(
    'ceq-tabs',
    class CeqTabs extends HTMLElement {
      constructor() {
        super();
        
        
      }

      connectedCallback() {
        this.tab_pills = this.querySelectorAll('li');

        this.tab_pills.forEach(li => {
          const ln = li.querySelector('a');

          ln.addEventListener('click', (e) => {
            e.preventDefault();

            let currentLn = e.target;
            let parent = currentLn.closest('.ceq-tabs');
            if( parent ) {
              parent.querySelectorAll('li').forEach((li) => {
                li.querySelector('a').setAttribute('data-ceq-tab-active', 'false');
              });
            }

            currentLn.setAttribute('data-ceq-tab-active', 'true');

            this.selectTab(e.target);
          })
          
          this.selectTab(ln);
        });
      }

      selectTab(ln) {
        if( ln && ln.hasAttribute('data-ceq-tab-active') && ln.getAttribute('data-ceq-tab-active') == 'true' ) {
          const href = ln.getAttribute('href');
          if( href ) {
            document.querySelectorAll('[data-tab-parent-id]').forEach((section) => {
              section.classList.add('hidden');
              section.classList.add('ceq-tab-inactive');
              section.classList.remove('ceq-tab-active');
              
              if( section.getAttribute('data-tab-parent-id') == href.replace('#','') ) {
                section.classList.remove('hidden');                
                section.classList.remove('ceq-tab-inactive');
                section.classList.add('ceq-tab-active');
              }
            });
          }
          
        }
      }
    }
  );
}
